import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Compass, Wallet, BrainCircuit } from 'lucide-react';
const pains = [{
  icon: Compass,
  text: 'No sabés por dónde empezar',
  description: 'La información en internet es abrumadora y contradictoria.'
}, {
  icon: XCircle,
  text: 'Probaste cosas pero no funcionaron',
  description: 'Invertiste tiempo y esfuerzo sin ver resultados reales.'
}, {
  icon: Wallet,
  text: 'Pensás que necesitás plata o experiencia',
  description: 'Creés que hace falta un gran capital inicial para arrancar.'
}, {
  icon: BrainCircuit,
  text: 'Sentís que emprender es complicado',
  description: 'Te frena el miedo a la burocracia y a no saber vender.'
}];
export function PainSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-y border-white/5 relative overflow-hidden" data-id="element-184">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-warmBrown/20 blur-[100px] rounded-full pointer-events-none" data-id="element-185" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-187">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-balance leading-tight" data-id="element-188">
            El problema no es que no puedas emprender…{' '}
            <br className="hidden md:block" data-id="element-189" />
            <span className="text-gold italic font-normal" data-id="element-190">
              es que nadie te explicó cómo convertir algo simple en dinero
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 lg:gap-8" data-id="element-191">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-charcoal/50 border border-white/5 p-8 rounded-2xl flex gap-6 items-start group hover:bg-warmBrown/30 transition-colors duration-300" data-id="element-192">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-charcoal flex items-center justify-center border border-white/10 group-hover:border-gold/30 transition-colors" data-id="element-193">
                <pain.icon className="w-6 h-6 text-cream-muted group-hover:text-gold transition-colors" data-id="element-194" />
              </div>
              <div data-id="element-195">
                <h3 className="text-xl font-semibold mb-2 text-cream" data-id="element-196">
                  {pain.text}
                </h3>
                <p className="text-cream-muted/70 text-base leading-relaxed" data-id="element-197">
                  {pain.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}